import React, {useState, createContext} from 'react';
import {PopoutPanel, PopoutPanelProps} from './PopoutPanel';
import './ArrPopoutPanel.scss';

// Types Definitions
// ----------------------------------
export interface IPopout {
  isPopoutOpen: boolean;
  setIsPopoutOpen: (value: boolean) => void | null;
}
// -------------------

const panelContext = createContext({
  isPopoutOpen: false,
  setIsPopoutOpen: (_val: boolean) => {},
});

// ----------------------------------
// PanelProvider Component
// ----------------------------------
export const PanelProvider: React.FC<PopoutPanelProps> = ({children}) => {
  const [isPopoutOpen, setIsPopoutOpen] = useState<boolean>(false);
  return (
    <panelContext.Provider value={{isPopoutOpen, setIsPopoutOpen}}>
      {children}
    </panelContext.Provider>
  );
};

// ----------------------------------
// ArrPopoutPanel Component
// ----------------------------------
const ArrPopoutPanel: React.FC<PopoutPanelProps> = ({children, ...props}) => {
  return (
    <PanelProvider>
      <PopoutPanel {...props}>{children}</PopoutPanel>
    </PanelProvider>
  );
};

export {ArrPopoutPanel, panelContext};
export default ArrPopoutPanel;
